import { FC } from 'react';
import Chip from './';
import { EvaluatedLevel } from '@/lib/models/user-event';
import { ChipColor, ChipSize } from './helpers';

interface Props {
  value: EvaluatedLevel;
  size?: ChipSize;
  showRiskLabel?: boolean;
}

const ColorMap: Map<EvaluatedLevel, ChipColor> = new Map();
ColorMap.set('low', 'success');
ColorMap.set('medium', 'warning');
ColorMap.set('high', 'error');
ColorMap.set('CRITICAL', 'critical');
ColorMap.set('PUBLIC', 'success');
ColorMap.set('INTERNAL', 'warning');
ColorMap.set('unknown', 'grey');
ColorMap.set('CONFIDENTIAL', 'error');

const RiskChip: FC<Props> = ({ value, size = 'small', showRiskLabel = false }) => {
  const color = ColorMap.get(value) || 'grey';
  let label = String(value).toLowerCase();

  if (['public', 'internal'].includes(value)) {
    label = 'not sensitive';
  }

  const riskLabel = showRiskLabel ? `${label} risk` : label;

  return <Chip label={riskLabel.toUpperCase()} color={color} size={size} />;
};

export default RiskChip;
